export const orderItemsInOrderFilter = {
  name: "orderItemsInOrderFilter",
  criterions: [
    {
      extension: null,
      placeholder: "",
      width: 200,
      value: null,
      type: "TextCriterion",
      extensionType: null,
      extensionValue: null,
      ordinate: 1,
      label: "Nr biletu/rez.",
      propertyName: "TicketNumber",
      canDelete: true,
      isRequired: false,
      isVisible: true,
      tooltip: "",
    },
    {
      extension: null,
      placeholder: "",
      width: 200,
      value: null,
      type: "TextCriterion",
      extensionType: null,
      extensionValue: null,
      ordinate: 2,
      label: "Nazwisko pasażera",
      propertyName: "ClientNameSurname",
      canDelete: true,
      isRequired: false,
      isVisible: true,
      tooltip: "",
    },
    {
      value: false,
      type: "BooleanCriterion",
      extensionType: null,
      extensionValue: null,
      ordinate: 3,
      label: "Pozycje ze zwrotem2",
      propertyName: "RefundBookingItems",
      canDelete: true,
      isRequired: false,
      isVisible: true,
      tooltip: "",
    },
  ],
};
